<template>
  <div class="pins-report relative">
    <report-header
      v-if="report"
      :error.sync="error"
      :report="report"
    >
      <template #title>
        member pin code report
      </template>
      <template #subtitle>
        analyze and download the number of members who have set <br />
        up a pin code
      </template>
    </report-header>
    <div class="mt-12">
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-3xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ totalMember }}
          </span>
        </div>
        <div class="text-lg w-48">total {{ totalMember > 1 ? 'members' : 'member' }}</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-2xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ optedInToSms }}
          </span>
        </div>
        <div class="text-lg w-48">opted in to sms</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-xl">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else class="font-primary">
            {{ withPinCode }}
          </span>
        </div>
        <div class="text-lg w-48">with a pin code</div>
      </div>
      <div class="flex justify-center items-center my-4">
        <div class="w-32 flex justify-center items-center text-center text-xl font-medium">
          <loading-icon v-if="loadingReport" class="loading-icon" />
          <span v-else>
            {{ percentWithPin }}%
          </span>
        </div>
        <div class="text-lg w-48">
          of members who are opted in have a pin code
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoadingIcon } from '@springbig/sb-components';
import { reportsAPI } from '../../services/api/reportsAPI';
import ReportHeader from "./ReportHeader.vue";

export default {
  name: 'PinsReport',
  components: {
    LoadingIcon,
    ReportHeader
  },
  data() {
    return {
      report: null,
      error: {},
      loadingReport: false
    }
  },
  computed: {
    optedInToSms(){
      return this.report?.output_data?.opt_in_count ?? 0;
    },
    percentWithPin(){
      return this.report?.output_data?.percent_with_pin ?? 0;
    },
    totalMember(){
      return this.report?.output_data?.total_count ?? 0;
    },
    withPinCode(){
      return this.report?.output_data?.with_pin_count ?? 0;
    }
  },
  async created() {
    this.loadingReport = true;
    try {
      const { report } = await reportsAPI.createReport('Reports::MembersWithPinsReport');
      this.report = report;
    }
    catch (error) {
      this.error.message =  "error, please refresh or contact support";
    }
    this.loadingReport = false;
  }
}
</script>

<style lang="scss" scoped>
.pins-report {
  .loading-icon {
    width: 35px!important;
  }
}
</style>